import { ClientUser } from "../types/user";
import { ApiUser } from "../types/user/api-types";
import { OrderAdapter } from "./order-adapter";

export const userAdapter = {
  toClientUser(apiUser: ApiUser): ClientUser {
    return {
      ...apiUser,
      phoneNumber: apiUser.phone_number,
      ordersHistory:
        apiUser.orders_history?.map(OrderAdapter.toClientOrder) || null,
    };
  },
};
